import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { fetchSocials } from "../lib/api";
import { SocialIcons } from "./Socials";

export default function Footer() {
    const { t } = useTranslation();
    const [socials, setSocials] = useState(null);
    useEffect(() => { fetchSocials().then(setSocials); }, []);

    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-slate-950 mt-32">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-4 mb-6">
                        <img
                            src="https://customer-assets.emergentagent.com/job_polar-token-land/artifacts/h5uomzcw_immagine.png"
                            alt="The Portal"
                            className="h-14 w-14 object-contain rounded-full ring-1 ring-white/10"
                        />
                        <div>
                            <div className="font-serif text-2xl tracking-[0.25em] uppercase">
                                The <span className="text-frost">Portal</span>
                            </div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-slate-500 mt-1">
                                {t("footer.subtitle")}
                            </div>
                        </div>
                    </div>
                    <div className="font-serif text-3xl tracking-tight">
                        {t("footer.title_1")}<br />
                        <span className="text-frost italic">{t("footer.title_2")}</span>
                    </div>
                    <div className="mt-6">
                        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">
                            {t("footer.follow")}
                        </p>
                        <SocialIcons socials={socials} size="md" />
                    </div>
                </div>
                <div>
                    <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
                        {t("footer.explore")}
                    </p>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/explorer" className="hover:text-frost">{t("nav.explorer")}</Link></li>
                        <li><Link to="/auctions" className="hover:text-frost">{t("nav.auctions")}</Link></li>
                        <li><Link to="/my-tokens" className="hover:text-frost">{t("nav.my_tokens")}</Link></li>
                        <li><Link to="/about" className="hover:text-frost">{t("nav.about")}</Link></li>
                    </ul>
                </div>
                <div>
                    <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
                        {t("footer.external")}
                    </p>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a data-testid="opensea-link" href="https://opensea.io" target="_blank" rel="noreferrer"
                                className="inline-flex items-center gap-1 hover:text-frost">
                                OpenSea <ArrowUpRight className="w-3 h-3" />
                            </a>
                        </li>
                        <li>
                            <a href="#" className="inline-flex items-center gap-1 hover:text-frost">
                                Polygonscan <ArrowUpRight className="w-3 h-3" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-4">
                    <p className="text-xs text-slate-500 font-mono">{t("footer.copyright")}</p>
                    <p className="text-xs text-slate-500 font-mono">{t("footer.specs")}</p>
                </div>
            </div>
        </footer>
    );
}
